import Picker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled, { css } from 'styled-components';
import { colors, media } from 'tsx/theme';

interface Props {
  error?: boolean;
  $fullWidth?: boolean;
}

export const DatePicker = styled(Picker)<Props>`
  border: 1px solid ${colors.primary};
  height: 48px;
  border-radius: 50px;
  padding: 0 15px;
  min-width: 100px;
  background-color: transparent;

  &::placeholder {
    opacity: 0.5;
    color: ${colors.text};
  }

  &:focus {
    outline: 1px solid ${colors.primary};
  }

  &:hover {
    outline: 1px solid ${colors.primary};
  }

  ${({ error }) =>
    error &&
    css`
      border: 1px solid red;
      &:focus {
        outline: 1px solid red;
      }
      &:hover {
        outline: 1px solid red;
      }
    `};

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}

  ${media.md(css`
    height: 35px;
    font-size: 14px;
  `)};
`;
